export default __webpack_public_path__ + "static/media/posts.82f3438e.svg";